// extracted by mini-css-extract-plugin
export var cardHeader = "_f8-0";
export var reorderHandle = "_f8-3";
export var titleArea = "_f8-1";
export var titleAreaWithHandle = "_f8-2";